<template>
  <div
    class="flex flex-col items-center justify-between"
    v-bind:class="[{ fetched: data && data.pending == false && data.failed == false }]"
  >
    <transition name="fade" mode="out-in">
      <Card v-if="data && data.pending == false && data.failed == false" class="icon"/>
      <NotFound v-else-if="data && data.pending == false && data.failed == true" class="icon"/>
      <div v-else class="sk-fading-circle">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
      </div>
    </transition>
    <div>
      <h6 class="heading">CUENTA</h6>
      <h2 class="heading">{{ name }}</h2>
    </div>
  </div>
</template>

<script>
import Card from "@/icons/credit-card-outline.svg";
import NotFound from "@/icons/not-found.svg";
import Loading from "@/icons/loading.svg";
import { Stream } from "stream";
export default {
  name: "Accounts-Item",
  props: {
    name: String,
    id: [String, Number],
    sub_id: [String, Number]
  },
  components: {
    Card,
    Loading,
    NotFound
  },
  computed: {
    data() {
      return this.$store.getters.getAccount({
        id: this.id,
        sub_id: this.sub_id
      });
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
